// 气象站详情
export default {
    equipmentName: 'Equipment name',
    altitude: 'Altitude',
    firmwareVersion: 'Firmware version',
    position: 'Position',
    windSpeed: 'Wind speed',
    windDirection: 'Wind direction',
    temperature: 'Temperature',
    humidity: 'Humidity',
    airPressure: 'Air pressure',
    cumulativeTime: 'Cumulative time',
    export: 'Export',
    lastWeek: 'Last week',
    lastMonth: 'Last month',
    lastThreeMonths: 'Last three months',
    time: 'Time',
    northWind: 'North Wind',
    northeastWind: 'Northeast Wind',
    eastWind: 'East Wind',
    southeastWind: 'Southeast Wind',
    southWind: 'South Wind',
    southwestWind: 'Southwest Wind',
    weatWind: 'Weat Wind',
    northwestWind: 'Northwest Wind',
}